import type { LucideIcon } from 'lucide-react';

export interface CreateMenuItem {
  label: string;
  desc: string;
  icon: LucideIcon;
  bg: string;
  color: string;
  action: () => void;
}

interface CreateMenuProps {
  items: CreateMenuItem[];
  onSelect: (action: () => void) => void;
}

export function CreateMenu({ items, onSelect }: CreateMenuProps) {
  return (
    <div
      style={{
        position: 'absolute',
        top: 'calc(100% + 6px)',
        right: 0,
        background: 'var(--card)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-lg)',
        border: '1px solid var(--border)',
        minWidth: 200,
        zIndex: 200,
        overflow: 'hidden',
        animation: 'fadeSlideIn 0.12s ease-out',
      }}
    >
      {items.map((item, i, arr) => {
        const Icon = item.icon;
        return (
          <button
            key={item.label}
            onClick={() => onSelect(item.action)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.6rem',
              width: '100%',
              padding: '0.65rem 0.9rem',
              background: 'none',
              border: 'none',
              borderBottom: i < arr.length - 1 ? '1px solid var(--border-light)' : 'none',
              fontSize: '0.85rem',
              color: 'var(--text)',
              textAlign: 'left',
              cursor: 'pointer',
              transition: 'background 0.1s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            <span
              style={{
                width: 28,
                height: 28,
                borderRadius: 'var(--radius-sm)',
                background: item.bg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                color: item.color,
              }}
            >
              <Icon size={15} />
            </span>
            <div>
              <div style={{ fontWeight: 600, lineHeight: 1.2 }}>{item.label}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{item.desc}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
